// extracted by mini-css-extract-plugin
module.exports = {"green":"TodoStatus_green__3RyA6","blue":"TodoStatus_blue__3KECZ","red":"TodoStatus_red__1ZmiF"};